import { render } from "./Header.vue?vue&type=template&id=1704413c&scoped=true&bindings={}"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=1704413c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1704413c"

export default script